export default "__VITE_ASSET__B5vbV4Nc__"